import { render, staticRenderFns } from "./testimonies.vue?vue&type=template&id=6e5481fc"
import script from "./testimonies.vue?vue&type=script&lang=js"
export * from "./testimonies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports